var tooltipStyle = {"wrapper":"_h-wrapper-7b37","breakLine":"_h-breakLine-177c","mainBlock":"_h-mainBlock-c7dc","line":"_h-line-8d1d"};

export { tooltipStyle as t };
